import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { html, nothing } from "lit";
import { styles } from "./styles.js";
import "../../atom/Text/index.js";
import { ifDefined } from "lit-html/directives/if-defined.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfToggle = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_checked = false;
    this.dsf_right = false;
    this.dsf_size = "medium";
    this.disabled = false;
  }
  onChange(evt) {
    const { checked } = evt.target;
    this.dsf_checked = checked;
    this.emit({ name: "change", payload: checked });
  }
  render() {
    const text = html`
      <dsf-text dsf_level=${this.dsf_size === "small" ? "xs" : "s"}>${this.dsf_label}</dsf-text>
    `;
    const labelPadding = this.dsf_label && `dsf-m${this.dsf_right ? "r" : "l"}-s`;
    const focusClass = `peer-focus:shadow-focus-${this.dsf_checked ? "secondary" : "neutral"}-sm`;
    return html`
      <div class="flex flex-row items-center" data-skeleton>
        ${this.dsf_right ? nothing : text}
        <label class="toggle ${labelPadding}">
          <input
            class="peer"
            aria-label=${ifDefined(this.dsf_label)}
            type="checkbox"
            .disabled=${this.disabled}
            ?checked=${this.dsf_checked}
            @change=${this.onChange}
          />
          <span class=${`slider ${focusClass}`}></span>
        </label>
        ${this.dsf_right ? text : nothing}
      </div>
    `;
  }
};
DsfToggle.styles = [...BaseComponent.styles, styles];
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfToggle.prototype, "dsf_checked", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfToggle.prototype, "dsf_right", 2);
__decorateClass([
  prop({ type: String, reflect: true })
], DsfToggle.prototype, "dsf_size", 2);
__decorateClass([
  prop({ type: Boolean, reflect: true })
], DsfToggle.prototype, "disabled", 2);
__decorateClass([
  prop({ type: String })
], DsfToggle.prototype, "dsf_label", 2);
DsfToggle = __decorateClass([
  defineElement("dsf-toggle")
], DsfToggle);
export {
  DsfToggle
};
